import React, { useEffect, useState } from "react";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import { listenToPlatformDailyRevenue, listenToPlatformRevenueRoot } from "../../../../redux/revenueSlice";





export default function CommerceRevenue() {
  const [open, setOpen] = useState(false);
const dispatch = useDispatch<AppDispatch>();
const user = useSelector((state: RootState) => state.auth.user);


const totalRevenue = useSelector(
  (state: RootState) => state.revenue.totalRevenue
);
const generalCommerceRevenue = useSelector(
  (state: RootState) => state.revenue.generalCommerceRevenue
);


const formatEuro = (amount: number) => {
  const formatted = new Intl.NumberFormat("en-US", {
    useGrouping: true,           // 👈 enables commas
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }).format(amount || 0);

  return `€ ${formatted}`;
};



useEffect(() => {
  if (!user?.isDirector) return;

  const unsubRoot = dispatch(
    listenToPlatformRevenueRoot(user.userId)
  );

  const unsubDaily = dispatch(
    listenToPlatformDailyRevenue(user.userId)
  );

  return () => {
    unsubRoot?.();
    unsubDaily?.();
  };
}, [dispatch, user]);

  return (
    <div style={styles.centerWrap}>
      <aside style={styles.stickyCard}>

        {/* 🏠 LISTING SUMMARY (PLACEHOLDER) */}
        <section style={styles.listingCard}>
<div style={styles.listingLeft}>
  <div style={styles.revenueLabel}>Total Revenue</div>
  <div style={styles.revenueAmount}>
    {formatEuro(totalRevenue)}
  </div>
</div>


         <div style={styles.listingImageWrap}>
  {user?.profilePicture ? (
    <img
      src={user.profilePicture}
      alt="Profile"
      style={styles.listingImage}
    />
  ) : (
    <div style={styles.imagePlaceholder} />
  )}
</div>

        </section>

        {/* 📅 INPUT CARD */}
        <div style={styles.inputCard}>
          <div style={styles.grid2}>
            <div style={styles.inputCell}>
              <div style={styles.inputLabel}>TAXES</div>
              <div style={styles.inputValue}>DD MMM YYYY</div>
            </div>

            <div style={{ ...styles.inputCell, borderLeft: "1px solid #ddd" }}>
              <div style={styles.inputLabel}>MORE</div>
              <div style={styles.inputValue}>DD MMM YYYY</div>
            </div>
          </div>

          <div style={styles.guestRow}>
            <div style={styles.inputLabel}>Volume</div>
            <div style={styles.inputValue}>
              100K
            </div>
          </div>
        </div>

        <div style={{ flex: 1 }} />

        {/* 🔴 PAY BUTTON (DUMB) */}
        <button style={styles.reserveBtn}>
          WITHDRAW
        </button>

        {/* ℹ️ NOTE */}
        <section style={styles.card}>
          <div style={styles.mutedText}>
            You will be directed to Stripe
          </div>
        </section>



       {/* 📕 REVENUE DETAILS */}
<div style={styles.bookCard}>
  <div
    style={styles.bookHeader}
    onClick={() => setOpen(o => !o)}
  >
    <strong>Revenue Details</strong>
    {open ? <ExpandLess /> : <ExpandMore />}
  </div>

  <motion.div
    initial={false}
    animate={{
      height: open ? "auto" : 0,
      opacity: open ? 1 : 0,
    }}
    transition={{ duration: 0.4, ease: "easeInOut" }}
    style={styles.whitePage}
  >
    <div style={styles.pageTop} />

    <div style={styles.pageContent}>
      <div style={styles.sectionHeader}>
        Root Revenue Document
      </div>

      <div style={styles.tableRow}>
        <span>General Commerce Revenue</span>
        <span>{formatEuro(generalCommerceRevenue)}</span>
      </div>

      <div style={styles.tableRow}>
        <span>Total Revenue</span>
        <span>{formatEuro(totalRevenue)}</span>
      </div>
    </div>
  </motion.div>
</div>



        {/* 📕 BOOK (EMPTY) */}
        <div style={styles.bookCard}>
          <div
            style={styles.bookHeader}
            onClick={() => setOpen(o => !o)}
          >
            <strong>Payment details</strong>
            {open ? <ExpandLess /> : <ExpandMore />}
          </div>

          <motion.div
            initial={false}
            animate={{
              height: open ? "auto" : 0,
              opacity: open ? 1 : 0,
            }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            style={styles.whitePage}
          >
            <div style={styles.pageTop} />
            <div style={styles.pageContent} />
          </motion.div>
        </div>

      </aside>
    </div>
  );
}



/* ───────────── STYLES ───────────── */

const styles: Record<string, React.CSSProperties> = {
  centerWrap: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 16px",
  },

 
stickyCard: {
  width: "100%",
  maxWidth: 520,
  minWidth: 340,
  border: "1px solid #eee",
  borderRadius: 18,
  padding: 24,
  boxShadow: "0 10px 30px rgba(0,0,0,.12)",
  display: "flex",
  flexDirection: "column",
  minHeight: 440,
  background: "#fff",
},


  card: {
    padding: 16,
    borderRadius: 16,
    border: "1px solid #eee",
    marginBottom: 12,
  },

  featuredRevenue: {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  background: "#111", // 🔥 black background
  padding: "16px 18px",
  borderRadius: 14,
  flex: 1,
},
revenueLabel: {
  fontSize: 13,
  fontWeight: 700,
  color: "#666",
},

revenueAmount: {
  fontSize: 28,
  fontWeight: 900,
  color: "#111", // 👈 force dark text
},

  mutedText: {
    fontSize: 13,
    color: "#666",
  },

  inputCard: {
    border: "1px solid #ddd",
    borderRadius: 12,
    overflow: "hidden",
    marginBottom: 16,
    background: "#fff",
  },

  grid2: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
  },

  guestRow: {
    borderTop: "1px solid #ddd",
    padding: "10px 12px",
  },

  inputCell: {
    padding: "12px 14px",
  },

  inputLabel: {
    fontSize: 10,
    fontWeight: 900,
    letterSpacing: 0.6,
    color: "#222",
  },

  inputValue: {
    fontSize: 14,
    fontWeight: 600,
    marginTop: 2,
    color: "#717171",
  },

  reserveBtn: {
    width: "100%",
    padding: 14,
    background: "#cc0000",
    border: "none",
    fontWeight: 900,
    cursor: "pointer",
    color: "#fff",
    fontSize: 16,
    marginBottom: 16,
  },

  listingCard: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 14,

  padding: 16,
  borderRadius: 16,
  border: "1px solid #eee",
  marginBottom: 12,
  background: "#fff",
},

listingLeft: {
  display: "flex",
  flexDirection: "column",
  gap: 6,
  flex: 1,
},

listingTitle: {
  fontSize: 15,
  fontWeight: 900,
  lineHeight: 1.25,
  color: "#222",
},

listingAddress: {
  fontSize: 13,
  color: "#717171",
  lineHeight: 1.3,
},

listingImageWrap: {
  width: 64,
  height: 64,
  borderRadius: 12,
  overflow: "hidden",
  cursor: "pointer",
  flexShrink: 0,
  boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
},

listingImage: {
  width: "100%",
  height: "100%",
  objectFit: "cover",
},

  /* 📕 BOOK */
/* 📕 BOOK */
bookCard: {
  background: "#fff",
  border: "2px solid #cc0000", // 🔴 red border
  borderRadius: 20,
  padding: 24,
  width: "87%",
  maxWidth: 480,
  boxShadow:
    "0 10px 25px rgba(0,0,0,.12), inset 0 0 6px rgba(0,0,0,.04)",
},

  bookHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  bookTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#ff48a5",
  },
  coverSection: {
    position: "relative",
    marginTop: 16,
    borderRadius: 14,
    overflow: "hidden",
    boxShadow: "0 6px 18px rgba(255,72,165,0.4)",
  },
  image: { width: "100%", height: 200, objectFit: "cover" },
  coverOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "linear-gradient(transparent, rgba(0,0,0,0.9))",
    padding: "12px 16px",
  },
  coverTitle: { fontSize: 14, color: "#ddd" },
  coverAmount: {
    fontSize: 28,
    fontWeight: 800,
    color: "#ffd700",
    textShadow: "0 0 8px rgba(255,215,0,.4)",
  },
  whitePage: {
    background: "#fff",
    borderRadius: 14,
    marginTop: 16,
    boxShadow: "inset 0 0 8px rgba(0,0,0,.05),0 3px 12px rgba(0,0,0,.25)",
  },
  pageTop: {
    height: 4,
    background: "repeating-linear-gradient(90deg,#ddd 0 10px,#fff 10px 20px)",
  },
  pageContent: {
    padding: "16px 20px",
    background: "repeating-linear-gradient(#fff, #fff 28px, #f7f7f7 29px)",
  },
  tableRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 14,
    color: "#222",
    padding: "8px 0",
    borderBottom: "1px dashed rgba(0,0,0,0.08)",
  },
  sectionHeader: {
    marginTop: 16,
    marginBottom: 10,
    fontWeight: 700,
    color: "#ad1212ff",
  },
  downloadBtn: {
    width: "100%",
    marginTop: 20,
    background: "linear-gradient(145deg,#b700ff,#ff48a5,#ffd700)",
    border: "none",
    borderRadius: 40,
    color: "#fff",
    fontWeight: 700,
    fontSize: 16,
    padding: "12px 0",
    cursor: "pointer",
    boxShadow: "0 6px 20px rgba(0,0,0,0.5)",
  },
  loading: {
    background: "#000",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
  },



};
